import './BulkEditProperties.scss';
import Component from './BulkEditProperties.js';
export default Component;
